// removed by extract-text-webpack-plugin
module.exports = {"slick-slider":"slick-slider","slick-list":"slick-list","dragging":"dragging","slick-track":"slick-track","slick-loading":"slick-loading","slick-slide":"slick-slide","slick-initialized":"slick-initialized","slick-vertical":"slick-vertical","slick-arrow":"slick-arrow","slick-hidden":"slick-hidden"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/slick-carousel/slick/slick.scss
// module id = ./node_modules/slick-carousel/slick/slick.scss
// module chunks = 0